<template>
<div class="chapter">
<div class="inner_page">
<div class="foreward" id="foreward">
<h3 class="chapterTitle"><em class="italic">FOREWORD</em></h3>
<p class="chapterTitle1"><span class="character-style6">AIR MARSHAL SIR ROGER AUSTIN<br/>KCB AFC FRAES RAF (RET’D)</span></p>
<div class="extract">
<p class="extractText1"><span class="character-style7">History with its flickering lamp stumbles along the trail of the past, trying to reconstruct its scenes, to revive its echoes, and kindle with pale gleams the passion of former days.</span></p>
</div>
<p class="paraRight2"><span class="character-style7">Winston Churchill</span></p>
<p class="paraNoIndent1"><span class="character-style7">The history of air warfare is well documented because every take-off, every landing and every engagement of the enemy was logged and recorded. That record of action is generally accurate and comprehensive but statistics alone do not tell the full story. To complete the picture, eye-witness accounts are invaluable as they bring the story to life by illustrating the tension, the emotions and the atmosphere surrounding the events.</span></p>
<p class="para"><span class="character-style7">Steve Bond has done a remarkable job in gathering the tales of over 100 people from the armies, navies and air forces of six nations, both aircrew and ground crew, plus civilians such as Alex Henshaw. He has sensibly avoided the temptation to edit their contributions, thus preserving the very personal nature of their accounts which reveal their characters and the differing approaches of the various nations.</span></p>
<p class="para"><span class="character-style7">The result is a compelling and fascinating compilation of stories from every area of air warfare which add so much to the bare statistics. This is a first class book which will be a most useful reference for anyone with an interest in the history of air warfare.</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// HeroesAll_foreward.vue?5c56d420